// Wraps up top block articles //
$(document).ready(function () {
  $("ul.top-articles > li:first-child").wrapAll('<div class="big"></div>');
  $("ul.top-articles > li:not(:first-child)").wrapAll(
    '<div class="side"></div>'
  );
  $("ul.top-articles").addClass("top-articles--loaded");
});
